/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Markers_Lists_HelpInputs */



/**
* | output |
* | --- |
* | "Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module." |
*
* @param {Iconik_Publish_Markers_Lists_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_markers_lists_help = /** @type {((inputs?: Iconik_Publish_Markers_Lists_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Markers_Lists_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
	return /** @type {LocalizedString} */ ("Choose which marker lists to publish. They appear in Iconik's Time-Based Metadata module.")
});